<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item
          class="mr-20"
          v-if="orderType==='PLATFORM'"
        >
          <a-select
            allowClear
            placeholder="状态"
            v-model="queryParam.status"
            style="width: 180px"
          >
            <a-select-option
              v-for="item in dict.statusDict"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleExport"
        >导出</a-button>
        <a-radio-group
          v-model="orderType"
          @change="changeOrderType"
          style="float:right"
        >
          <a-radio-button value="PLATFORM">平台打印</a-radio-button>
          <a-radio-button value="LOCAL">自己打印</a-radio-button>
        </a-radio-group>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="orderType==='PLATFORM'?columns:columns2"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="orderId"
          slot-scope="text"
          style="word-break: break-all !important;"
        >
          {{ text }}
        </span>
        <span
          slot="start_sc_id"
          slot-scope="text, record"
        >
          {{ record.start_sc_id }} - {{ record.end_sc_id }}
        </span>
        <span
          slot="relation_type"
          slot-scope="text"
        >
          {{ text | valInDict(dict.relationTypeDict) }}
        </span>
        <span
          slot="receiver"
          slot-scope="text, record"
        >
          <template v-if="record.receiver">
            {{ record.receiver }}<br>{{ record.phone }}<br>{{ record.address }}
          </template>
          <template v-else>
            --
          </template>
        </span>
        <span
          slot="platform_status"
          slot-scope="text"
        >
          <a-tag :color="text |statusTagFilter">
            {{ text | valInDict(dict.statusDict) }}
          </a-tag>
        </span>
        <span
          slot="action"
          slot-scope="text, record"
        >
          <a-button
            type="link"
            @click="handleLook(record.order_id)"
          >查看</a-button>
          <a-button
            v-if="orderType==='PLATFORM'&&record.platform_status==='NORMAL'"
            type="link"
            @click="handlePay(record)"
          >支付</a-button>
          <a-button
            v-if="orderType==='PLATFORM'&&record.platform_status==='NORMAL'"
            type="link"
            @click="handleCancelOrder(record.orderId)"
          >取消订单</a-button>
          <a-button
            v-if="orderType==='PLATFORM'&&record.platform_status==='DELIVERED'"
            type="link"
            @click="handleConfirmReceive(record.orderId)"
          >确认收货</a-button>
          <a-button
            v-if="orderType==='LOCAL'||record.platform_status==='DONE'||record.platform_status==='CANCEL'"
            type="link"
            @click="handlePrint(record.order_id, record.relation_id, record.relation_type, record.relation_name)"
          >重新打印</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
    <!-- 支付面板弹框 -->
    <pay-panel
      ref="payPanel"
      :default-pay-type="curItem.pay_type"
      :price="curItem.payment_amount"
      order-type="PRINT"
      @close="handleFilter"
    />
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import PayPanel from '@/components/PayPanel'
import { getOrderPre, getPlatformOrderList, getLocalOrderList, postCancalOrder, postOrderReceived } from '@/api/print'
import { downloadFile } from '@/utils'

const defaultQueryParam = {
  searchType: 'orderId'
}

function getOrderType () {
  const ORDERTYPE = window.localStorage.getItem('ORDERTYPE')
  console.log(ORDERTYPE)
  return ORDERTYPE === null ? 'PLATFORM' : ORDERTYPE
}

export default {
  name: 'PrintHistory',
  components: { TcgTable, PayPanel },
  data() {
    return {
      orderType: getOrderType(), // 平台打印：PLATFORM、自己打印：LOCAL
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [],
        statusDict: [],
        relationTypeDict: []
      },
      curItem: {},
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderId',
          scopedSlots: { customRender: 'orderId' }
        },
        {
          title: '打印模板',
          dataIndex: 'template_name'
        },
        {
          title: '打印序号',
          dataIndex: 'start_sc_id',
          scopedSlots: { customRender: 'start_sc_id' }
        },
        {
          title: '打印数量',
          dataIndex: 'security_code_count'
        },
        {
          title: '类型',
          dataIndex: 'relation_type',
          scopedSlots: { customRender: 'relation_type' }
        },
        {
          title: '页面/商品名称',
          dataIndex: 'relation_name'
        },
        {
          title: '收货地址',
          dataIndex: 'receiver',
          scopedSlots: { customRender: 'receiver' }
        },
        {
          title: '状态',
          dataIndex: 'platform_status',
          scopedSlots: { customRender: 'platform_status' }
        },
        {
          title: '更新时间',
          dataIndex: 'update_time'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      columns2: [
        {
          title: '记录号',
          dataIndex: 'orderId',
          align: 'center',
          scopedSlots: { customRender: 'orderId' }
        },
        {
          title: '类型',
          dataIndex: 'relation_type',
          align: 'center',
          scopedSlots: { customRender: 'relation_type' }
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name',
          align: 'center'
        },
        {
          title: '页面/商品名称',
          dataIndex: 'relation_name',
          align: 'center'
        },
        {
          title: '打印模板',
          dataIndex: 'template_name',
          align: 'center'
        },
        {
          title: '打印序号',
          dataIndex: 'start_sc_id',
          align: 'center',
          scopedSlots: { customRender: 'start_sc_id' }
        },
        {
          title: '打印数量',
          dataIndex: 'security_code_count',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        if (this.orderType === 'PLATFORM') {
          // 平台打印
          return getPlatformOrderList(Object.assign(parameter, this.queryParam)).then((res) => {
            return res
          })
        } else {
          // 自己打印
          return getLocalOrderList(Object.assign(parameter, this.queryParam)).then((res) => {
            return res
          })
        }
      }
    }
  },
  created() {
    this.getPre()
  },
  watch: {
    orderType(val) {
      window.localStorage.setItem('ORDERTYPE', val)
    }
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.table.refresh(true)
    },
    // 预加载
    getPre() {
      getOrderPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.searchTypeDict = data.searchTypeDict
            this.dict.statusDict = data.statusDict
            this.dict.relationTypeDict = data.relationTypeDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载接口失败')
        })
    },
    // 修改打印方式
    changeOrderType(e) {
      this.handleReset()
    },
    // 查看
    handleLook(id) {
      this.$router.push({ name: 'orderDetail', query: { id: id } })
    },
    // 重新打印
    handlePrint(order_id, relation_id, relation_type, relation_name) {
      this.$router.push({ name: 'printCode', query: { order_id, relation_id, relation_type, relation_name } })
    },
    // 取消订单
    handleCancelOrder(id) {
      this.$confirm({
        title: '确定要取消订单?',
        onOk: () => {
          this.confirmLoading = true
          postCancalOrder({
            order_type: 'PRINT',
            orderId: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('取消订单成功')
                this.handleFilter()
              }
            })
            .catch((e) => {
              this.$message.error('取消订单失败')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 确认收货
    handleConfirmReceive(id) {
      this.$confirm({
        title: '是否确认收货?',
        onOk: () => {
          this.confirmLoading = true
          postOrderReceived({
            orderId: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('确认收货成功')
                this.handleFilter()
              }
            })
            .catch((e) => {
              this.$message.error('确认收货失败')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    // 支付
    handlePay(item) {
      this.curItem = item
      this.$refs.payPanel.showModal(item.orderId)
    },
    // 导出
    handleExport() {
      // PLATFORM
      let href = window.location.origin + '/merchant.php/order/platformOrderOutExcel'
      // if (this.orderType === 'PLATFORM') {
      //   // 360下载关闭问题
      //   // window.location.href = window.location.origin + '/merchant.php/order/platformOrderOutExcel'
      //   const href = window.location.origin + '/merchant.php/order/platformOrderOutExcel'
      // }
      if (this.orderType === 'LOCAL') {
        // window.location.href = window.location.origin + '/merchant.php/order/localOrderOutExcel'
        href = window.location.origin + '/merchant.php/order/localOrderOutExcel'
      }
      downloadFile(href)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
